import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "@/utils/createClassNameString";
import { tabletViewport } from "@/utils/tabletViewport";

import { getAutomationDataAttr } from "../../utils/automationUtils";
import { Info } from "../Info";
import { PopoverPositions } from "../constants";
import { testLocator } from "../../lib/helpers/test-locator";

import "./styles.scss";

export const Input = ({
  className,
  defaultValue,

  disabled,
  error,
  ignoreEnterSubmit,
  infoContent,
  inputClassName,
  name,

  onBlur,

  onChange,
  onFocus,
  placeholder,
  testId,

  value,
  ...props
}) => {
  const windowWidth = window.innerWidth;

  const getPointer = (el) => {
    if (el.selectionStart) {
      return el.selectionStart;
    }

    return 0;
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && ignoreEnterSubmit) {
      let content = e.target.value;
      let pointerPosition = getPointer(e.target);

      e.target.value =
        content.substring(0, pointerPosition) + content.substring(pointerPosition, content.length);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  let infoTestId;

  if (testId) {
    infoTestId = `${testId}-info`;
  }

  const dataTestId = props["data-testid"];

  return (
    <div className={createClassNameString(["apti-CL apti-Input--container", className])}>
      <input
        className={createClassNameString(["apti-CL apti-Input", inputClassName, error && "error"])}
        defaultValue={defaultValue}
        disabled={disabled}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        type="text"
        value={value}
        {...getAutomationDataAttr(testId)}
        {...props}
      />
      {infoContent && (
        <Info
          className="apti-Input--info"
          position={windowWidth < tabletViewport ? PopoverPositions.left : PopoverPositions.right}
          testId={infoTestId}
          {...testLocator(dataTestId && `${dataTestId}Info`)}
        >
          {infoContent}
        </Info>
      )}
    </div>
  );
};

Input.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  placeholder: PropTypes.string,
  testId: PropTypes.string,
  value: PropTypes.string,
};

Input.defaultProps = {
  className: undefined,
  defaultValue: undefined,
  disabled: false,
  error: false,
  name: "",
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  placeholder: "",
  testId: undefined,
  value: undefined,
};
